import lib from "../lib/lib.js";
import Splide from "@splidejs/splide";

const slider = {
  // Initialise Slider
  init: () => {
    if (document.querySelectorAll(".splide").length !== 0) {
      let splide = new Splide(".splide", {
        type: "loop",
        perPage: 6,
        breakpoints: {
          1080: {
            perPage: 4,
          },
          640: {
            perPage: 2,
          },
        },
      });
      splide.mount();
    }
  },
};

export { slider as default };
